import React from 'react';
import { Hidden } from '@vp/swan';
import PropTypes from 'prop-types';

const spacingMap = {
  s: '8px',
  m: '16px',
  l: '32px',
  xl: '64px',
};

/**
 * Component that acts as a (spacingMap[size] x spacingMap[size]) blank spacing block.
 * It will hide itself if the screen is xs and hiddenXS is true (same logic follows for sm, md, and lg screen sizes).
 */
export const Spacer = props => {
  const {
    size,
    hiddenXS = false,
    hiddenSM = false,
    hiddenMD = false,
    hiddenLG = false,
  } = props;

  return (
    <Hidden
      style={{ height: spacingMap[size], width: spacingMap[size] }}
      xs={hiddenXS}
      sm={hiddenSM}
      md={hiddenMD}
      lg={hiddenLG}
    />
  );
};

Spacer.propTypes = {
  size: PropTypes.string.isRequired,
  hiddenXS: PropTypes.bool,
  hiddenSM: PropTypes.bool,
  hiddenMD: PropTypes.bool,
  hiddenLG: PropTypes.bool,
};
